'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = loadIndexScript;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Async loader of indexExchange tag on client
 * @param {function} resolve callback function
 * @param {function} reject callback function
 */
var doloadScript = function doloadScript(resolve, reject) {
  /*
    do this after loading all
    googletag.cmd.push(() => {
      if (typeof window.headertag === 'undefined' ||
      window.headertag.apiReady !== true) {
      window.headertag = googletag;
    }
  });
  */
  if (typeof window.headertag !== 'undefined') {
    resolve(window.headertag);
  }
  var scriptTag = document.createElement('script');
  scriptTag.src = document.location.protocol + '//js-sec.indexww.com/ht/htw-univision.js';
  scriptTag.async = true;
  scriptTag.type = 'text/javascript';
  scriptTag.onerror = function scriptTagOnError(errs) {
    reject(errs);
  };
  scriptTag.onload = function scriptTagOnLoad() {
    resolve(window.headertag);
  };
  document.getElementsByTagName('head')[0].appendChild(scriptTag);
};

/**
 * Promise creator
 * @constructor
 */
function loadIndexScript() {
  return new _promise2.default(function (resolve, reject) {
    doloadScript(resolve, reject);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/ads/vendors/indexLoader.js
// module id = 288
// module chunks = 35783957827783